// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyBookings-myBookingSectionWrapper-POMl3 {
    padding: 24px;
    border-radius: var(--radius-3);
    background-color: var(--background-primary);
}

.MyBookings-myBookingSectionTitle-NnhNJ {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    color: var(--primary-foreground);
    margin-bottom: 18px;
    text-align: start;
}

.MyBookings-myBookingCardListContainer-fi9W1 {
    display: grid;
    gap: 18px;
    grid-gap: 18px;
}

.MyBookings-myBookingLoaderContainer-bdX1u {
    padding: 75px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/MyBookings/MyBookings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".myBookingSectionWrapper {\n    padding: 24px;\n    border-radius: var(--radius-3);\n    background-color: var(--background-primary);\n}\n\n.myBookingSectionTitle {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 30px;\n    color: var(--primary-foreground);\n    margin-bottom: 18px;\n    text-align: start;\n}\n\n.myBookingCardListContainer {\n    display: grid;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.myBookingLoaderContainer {\n    padding: 75px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"myBookingSectionWrapper": `MyBookings-myBookingSectionWrapper-POMl3`,
	"myBookingSectionTitle": `MyBookings-myBookingSectionTitle-NnhNJ`,
	"myBookingCardListContainer": `MyBookings-myBookingCardListContainer-fi9W1`,
	"myBookingLoaderContainer": `MyBookings-myBookingLoaderContainer-bdX1u`
};
module.exports = ___CSS_LOADER_EXPORT___;
